import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';
import CommonProps from '@groot-components/shared/mixins/props';
import FormsProps from '@groot-components/shared/mixins/forms/props';

/**
 * Uploader Props
 */
@Component
class Props extends Mixins(CommonProps, FormsProps) {
    /**
     * Dropzone Maximum File Size
     */
    @Prop({ type: [Number, String], default: 10 }) maxFileSize!: number | string;

    /**
     * Dropzone Maximum File Number
     */
    @Prop({ type: [Number, String], default: 100 }) maxFiles!: number | string;

    /**
     * Dropzone Accepted Mime Types
     */
    @Prop({ type: [Array, String], default: () => (['jpg', 'jpeg', 'png', 'gif', 'pdf']) }) acceptedFiles!: Array<any> | string;

    /**
     * Dropzone Request Header
     */
    @Prop({ type: [Object, String], default: () => ({}) }) headers!: {[k: string]: any} | string;

    /**
     * Dropzone Payload
     */
    @Prop({ type: String }) payload!: string;

    /**
     * Small single uploader
     */
   @Prop({ type: Boolean }) small!: Boolean;

   /**
    * Check is uploader is simple mode without modal
    */
   @Prop({ type: Boolean }) simple!: Boolean;

   /**
    * Uploaded files
    */
   @Prop({ type: Array }) files!: Array<any>;

   /**
    * Linear Mode Uploader
    */
   @Prop({ type: Boolean }) linear!: Boolean;

    /**
    * Show accepted files extension
    */
   @Prop({ type: Boolean }) showExtensions!: Boolean;

    /**
     * Dropzone options
     */
    @Prop({ type: Object, default: () => ({}) }) options!: {[k: string]: any};
}

export default Props;
